export const totalObjects = [

    {
      title: "PathFinder Algorithm Visualizer",
      projectUrl: "project1",
      text1:
      "The Pathfinder Project was built with a goal in mind: to test the performance index of the React JS framework relative to project scalability. Understanding that React is performance driven and it's useState functionality executes in real time, I decided to work on a project that stretches out it's re-rendering capability.",
      projectHref:
      "https://gracious-neumann-c1af48.netlify.app/",
    },
    {
      title: "DARKLOOK E-Commerce UI", 
      projectUrl: "project2",
      text1:
      "The E-Commerce UI was backed by a need to explore e-commerce user experience and understand the core features that users most interact with. This was a demo project used to secure a small client who wanted to have his site developed to handle his business",
      projectHref:
        "https://hopeful-lalande-3d524b.netlify.app/", 
    },
    {
      title: "E-Commerce With Stripe",
      projectUrl: "project3",
      text1:
      "This project's aim was to better understand the STRIPE Payment Gateway, how it is structured and how to possibly build an API Gateway.",
      projectHref:
      "https://suspicious-shockley-e04f0a.netlify.app/",
    },
    {
      title: "COVID 19 Tracker",
      projectUrl: "project4", 
      text1: "This project was inspired by the recent outbreak of the covid 19 Pandemic. Given the wild spread of the virus,the project was well underway. This project demonstrates a good understanding of API handling and async programming.",
      projectHref:
      "https://wash-your-handz.netlify.app/",
    },
];